import React, {useContext, useEffect} from 'react'
import {Form, InputNumber} from "antd";
import {OfferContext} from "../../../context/OfferContext";


const OfferDiscount = ({rowIndex, record}) => {

    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-lineDiscount`]: (record.data && record.data.discount) || 0
        })
    }, [rowIndex, record])

    const handleDiscountChange = ({target}) => {
        let mockContext = [...materials]
        mockContext[rowIndex].data.discount = target.value
        setMaterials(mockContext)
    }


    return(
        <React.Fragment>
            <Form
                form={form}
            >
                <Form.Item
                    name={`${rowIndex}-lineDiscount`}
                >
                    <InputNumber
                        disabled={!record.data}
                        onBlur={handleDiscountChange}
                        min={0}
                        max={100}
                        step={0.1}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferDiscount